import { render, staticRenderFns } from "./collaborator-form.vue?vue&type=template&id=43fd1f36"
import script from "./collaborator-form.vue?vue&type=script&lang=js"
export * from "./collaborator-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports